import { get, post } from "utilities/network";

export type SettlementCountry = "NG" | "GH" | "KE";
export type SettlementStatus = "all" | "credited" | "pending" | "failed";

const buildSettlementQuery = ({
  country,
  page,
  limit,
  status,
}: {
  country: SettlementCountry;
  page?: number;
  limit?: number;
  status?: SettlementStatus;
}) => {
  const params = new URLSearchParams();
  params.append("settlementCountry", country);
  if (page) params.append("page", String(page));
  if (limit) params.append("limit", String(limit));
  if (status) params.append("status", status);
  return params.toString();
};

export const httpFetchSettlements = (
  country: SettlementCountry,
  page: number = 1,
  limit: number = 50,
  status: SettlementStatus = "all",
) =>
  get(
    `admin/settlements?${buildSettlementQuery({
      country,
      page,
      limit,
      status,
    })}`,
  );

export const httpResolveSettlement = (settlementID: number, note: string) =>
  post(`admin/settlements/${settlementID}/resolve`, { note });

export const httpExportSettlements = (
  country: SettlementCountry,
  status: SettlementStatus = "all",
) =>
  get(
    `admin/settlements/export?${buildSettlementQuery({
      country,
      status,
    })}`,
  );
